module.exports = __webpack_public_path__ + "static/media/india.f3a60ba3.svg";